import * as Rx from 'rxjs';
import { map, tap } from 'rxjs/operators';

import type { WarningAlert, WarningResponse } from 'v2/interfaces/warning';

import apiService from './api';

import type { Observable } from 'rxjs';

/**
 * Service responsible for controlling `Warning` component.
 *
 * @class WarningsService
 */
class WarningsService {
  /**
   * @method loadGlobalWarnings
   * @return {Observable} an array of `WarningAlert` with the enabled warning alerts
   * returned by the API
   */

  private warnings$ = new Rx.BehaviorSubject<WarningAlert[]>(null);

  public getWarnings = (): Observable<WarningAlert[]> => this.warnings$;

  public loadGlobalWarnings = (): Observable<WarningAlert[]> => {
    return apiService.get<WarningResponse>('/alerts/self').pipe(
      map((response) => response.data),
      tap((warnings: WarningAlert[]) => this.warnings$.next(warnings))
    );
  };
}

const WarningsServiceFactory = new WarningsService();
export const warningsFactory = WarningsServiceFactory;
